import { Device } from "types/device.types";

/**
 * Alarm severity rank used for ordering: errors (> 255) first, then
 * warnings (1..255), then healthy devices. Pending/rejected links never show
 * alarm data, so they rank as healthy.
 */
const getAlarmRank = (device: Device): number => {
  if (device.linkStatus === "pending" || device.linkStatus === "rejected") {
    return 0;
  }
  const alarmValue = device.shadowData?.alarms ?? 0;
  if (alarmValue > 255) return 2;
  if (alarmValue >= 1) return 1;
  return 0;
};

/**
 * Returns a new array with devices that have errors, then warnings, on top.
 * The sort is stable, so the server order is kept inside each group.
 */
export const sortDevicesByAlarm = (devices: Device[]): Device[] =>
  [...devices].sort((a, b) => getAlarmRank(b) - getAlarmRank(a));
